<mat-list>
  <mat-list-item>
    <zah-avatar matListItemAvatar [name]="client.getNaam()"></zah-avatar>
    <div matListItemTitle>{{client.getNaam()}}</div>
    <div matListItemLine>{{client.getAdres() | zahStraat}}</div>
    <div matListItemLine>{{client.getAdres() | zahGemeente}}</div>
  </mat-list-item>
</mat-list>
